<template>
    <div>
        <v-list-item @click.stop="onDialog" link v-if="!hideTitleForm">
            <v-list-item-title>お相手選び入力</v-list-item-title>
        </v-list-item>
        <v-dialog v-model="dialogForm" persistent max-width="1200px">
            <v-card>
                <v-form ref="form">
                    <v-card-title class="justify-space-between">
                        お相手選び入力
                        <!-- <v-btn color="info">お相手選び ＣＯ画面へ</v-btn> -->
                    </v-card-title>
                    <v-card-text class="container grid-list-md body-content-dialog">
                        <v-layout wrap>
                            <v-flex xs6>
                                <v-select v-model="dataMatchingHistory.option.shift" :items="shifts"
                                    :rules="rules.shift" item-text="label" item-value="value" label="ｼﾌﾄ"
                                    @change="openDialogCV" :readonly="dataMatchingHistory.option.shift == 1"></v-select>
                            </v-flex>

                            <v-flex xs6>
                                <v-select v-model="dataMatchingHistory.kind" :items="kinds" :rules="rules.kind"
                                    item-text="text" item-value="value" label="取組区分" @change="changeKind"></v-select>
                            </v-flex>
                            <v-flex xs6 class="d-flex align-center">
                                <v-checkbox v-model="dataMatchingHistory.is_online" label="オンライン"></v-checkbox>
                            </v-flex>
                            <template
                                v-if="dataMatchingHistory.status != statusPlan && dataMatchingHistory.status != statusImplementation">
                                <v-flex xs6>
                                    <v-select v-model="dataMatchingHistory.status" :items="status" :rules="rules.status"
                                        item-text="text" item-value="value" label="状態"></v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-select v-model="dataMatchingHistory.option.result_TEL" :items="resultTELs"
                                        :rules="rules.resultTEL" item-text="label" item-value="value"
                                        label="相手選び結果TEL"></v-select>
                                </v-flex>
                            </template>
                            <template v-else>
                                <v-flex xs4>
                                    <v-select v-model="dataMatchingHistory.status" :items="status" :rules="rules.status"
                                        item-text="text" item-value="value" label="状態"></v-select>
                                </v-flex>
                                <v-flex xs4>
                                    <v-select v-model="dataMatchingHistory.option.result_TEL" :items="resultTELs"
                                        :rules="rules.resultTEL" item-text="label" item-value="value"
                                        label="相手選び結果TEL"></v-select>
                                </v-flex>
                                <v-flex xs4 class="d-flex align-center">
                                    <v-checkbox v-if="dataMatchingHistory.status == statusPlan"
                                        v-model="dataMatchingHistory.option.verTel" label="日時確認済"></v-checkbox>
                                    <v-checkbox v-if="dataMatchingHistory.status == statusImplementation"
                                        v-model="dataMatchingHistory.option.resTel" label="結果報告TEL済"></v-checkbox>
                                </v-flex>
                            </template>
                            <v-flex xs4>
                                <v-menu :close-on-content-click="false" transition="scale-transition" offset-y
                                    max-width="290px" min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="computedDateFormatted" :rules="rules.target_date"
                                            readonly label="お相手選び実施日" append-icon="mdi-calendar" persistent-hint
                                            v-bind="attrs" v-on="on" width="120px">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="dataMatchingHistory.target_date"
                                        :day-format="(target_date) => new Date(target_date).getDate()"
                                        no-title></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <!-- target_time -->
                            <v-flex xs4>
                                <v-dialog ref="dialog1" v-model="timePick['target_time']"
                                    :return-value.sync="dataMatchingHistory.target_time" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dataMatchingHistory.target_time"
                                            :rules="rules.target_time" label="実施時刻" readonly v-bind="attrs"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-time-picker v-if="timePick['target_time']"
                                        v-model="dataMatchingHistory.target_time" full-width scrollable format="24hr"
                                        @change="changeTimeStart($event)">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="timePick['target_time'] = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="saveTimeStart">
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-flex>
                            <!-- end at -->
                            <v-flex xs4>
                                <v-dialog ref="dialog2" v-model="timePick['target_time_end']"
                                    :return-value.sync="dataMatchingHistory.target_time_end" persistent width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="dataMatchingHistory.target_time_end"
                                            :rules="rules.target_time_end" label="終了時刻" readonly v-bind="attrs"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-time-picker v-if="timePick['target_time_end']"
                                        v-model="dataMatchingHistory.target_time_end" :min="minTime" full-width
                                        scrollable format="24hr">
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="timePick['target_time_end'] = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary"
                                            @click="$refs.dialog2.save(dataMatchingHistory.target_time_end)">
                                            OK
                                        </v-btn>
                                    </v-time-picker>
                                </v-dialog>
                            </v-flex>
                            <!-- phone -->
                            <v-flex xs6 v-if="dataMatchingHistory.kind != 9">
                                <v-text-field v-model="phone" :rules="rules.phone" type="text" label="携帯番号"
                                    @blur="verifyPhone($event)" ref="phone" :readonly="customerFromHistory">
                                </v-text-field>
                            </v-flex>
                            <!-- name -->
                            <v-flex xs6>
                                <v-autocomplete v-model="family_name" :rules="rules.family_name" label="本人会員名"
                                    @keydown="focusCustomerName" @update:search-input="debounce"
                                    @input="inputCustomerName" @blur="blurName" :items="itemFamilyNames"
                                    :readonly="customerFromHistory"></v-autocomplete>
                            </v-flex>
                            <!-- implementation CO -->
                            <v-flex :class="dataMatchingHistory.kind === kindVals.SOLO_INTRODUCTION ? 'xs12' : 'xs6'">
                                <v-select v-model="dataMatchingHistory.counselor_id"
                                    :items="customer && customer.shop_id !== null ? validCounselors : counselors"
                                    :rules="rules.counselor" item-text="name" item-value="id" label="実施CO"
                                    @change="onCounselorSelected">
                                    <template v-slot:item="{ item, attrs, on }">
                                        <v-list-item v-on="on" v-bind="attrs" :class="{'d-none': !(item.resignation_date == null || moment(item.resignation_date).format('YYYY/MM/DD') > moment().format('YYYY/MM/DD'))}">
                                            <v-list-item-title>
                                                {{ item.name }}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-flex xs6 v-if="dataMatchingHistory.kind !== kindVals.SOLO_INTRODUCTION">
                                <v-select v-model="dataMatchingHistory.booth_no_id" :items="validBoothNos"
                                    :rules="rules.boothNo" item-text="booth_no" item-value="id" label="ブース№"></v-select>
                            </v-flex>
                            <v-layout class="matching_histories" align-center
                                v-for="(matching_histories, i) in dataMatchingHistory.matching_histories" :key="i">
                                <!-- arrow menu -->
                                <v-flex d-flex flex-column justify-center align-center>
                                    <v-icon class="mdi-menu" @click="menuUp(i)">mdi-menu-up</v-icon>
                                    <v-icon class="mdi-menu" @click="menuDown(i)">mdi-menu-down</v-icon>
                                </v-flex>
                                <!-- member -->
                                <v-flex xs2>
                                    <v-text-field v-model="matching_histories.member" :label=textField.member
                                        type="text" @change="getCustomerHistory(i)" :rules="rules.member" tabindex="-1">
                                    </v-text-field>
                                </v-flex>
                                <!-- name -->
                                <v-flex xs2>
                                    <v-autocomplete v-model="matching_histories.name" :label=textField.name
                                        @keydown="focusMemberName($event, i)"
                                        @update:search-input="debounceMember($event, i)"
                                        @input="inputMemberName($event, i)" @blur="blurMemberName($event, i)"
                                        :items="itemMemberFamilyNames[i]" :readonly="memberFromHistory"
                                        tabindex="-1"></v-autocomplete>
                                </v-flex>
                                <!-- member type -->
                                <v-flex xs1>
                                    <v-text-field v-model="matching_histories.member_type" :label=textField.memberType
                                        type="text" readonly tabindex="-1">
                                    </v-text-field>
                                </v-flex>
                                <!-- shop name -->
                                <v-flex xs2>
                                    <v-text-field v-model="matching_histories.shop_name" type="text" tabindex="-1"
                                        readonly>
                                    </v-text-field>
                                </v-flex>
                                <!-- date -->
                                <v-flex xs2>
                                    <v-text-field v-model="computedDateFormatted" :label=textField.date type="text"
                                        readonly>
                                    </v-text-field>
                                </v-flex>
                                <!-- individual result -->
                                <v-flex xs1>
                                    <v-select v-model="matching_histories.individual_result" :items="individualResults"
                                        item-text="label" item-value="value"
                                        :label=textField.individualResult></v-select>
                                </v-flex>
                                <!-- opponent result -->
                                <v-flex xs1>
                                    <v-select v-model="matching_histories.opponent_result" :items="opponentResults"
                                        item-text="label" item-value="value" :label=textField.opponentResult></v-select>
                                </v-flex>
                                <!-- comment -->
                                <v-flex xs2>
                                    <v-text-field v-model="matching_histories.comment" :label=textField.comment
                                        type="text">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs1>
                                    <v-btn @click="remove(i)" small class="error">行削除</v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout reverse>
                                <v-flex xs1 v-if="dataMatchingHistory.matching_histories.length < (dataMatchingHistory.kind === kindVals.SOLO_INTRODUCTION ? 10 : 5)">
                                    <v-btn @click="addField" xs1 small class="info">行追加</v-btn>
                                </v-flex>
                            </v-layout>
                            <!-- note -->
                            <v-flex xs12>
                                <v-textarea 
                                  label="メモ"
                                  v-model="dataMatchingHistory.note"
                                  :rules="rules.note"
                                  :rows="3"
                                  @input="onMemoInput"
                                  @click="onMemoClick"
                                  ref="memoTextarea"
                                  class="memo-textarea"
                                >
                                </v-textarea>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn width="132" class="info" @click="checkHistory">登録</v-btn>
                        <v-btn width="132" class="secondary" @click="closeDialog">戻る</v-btn>
                        <v-btn width="132" class="error" v-if="typeSubmit == 'update'" @click="resetForm">削除</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <CompanyVisit :shop_id="shop_id" :date="date" :dialogCV="dialogCV" @closeDialogCV="closeDialogCV"
            :boothNos="boothNos" :counselors="counselors" :hideTitle="true" :valueKindForShift="kindShift" />
        <v-dialog width="500" v-model="showConfirmCustomerSame" persistent>
            <template>
                <v-card title="Dialog">
                    <v-card-text class="pt-5">
                        こちらの会員様は過去に紹介履歴があります。
                        <br />
                        確認をお願いします。
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn @click="closePopChangeCustomerSame" class="info">そのまま</v-btn>
                        <v-btn @click="changeCustomerSame">変更する</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
        
        <MemoEditorDialog
          :visible.sync="memoDialog"
          v-model="dataMatchingHistory.note"
          :rules="rules.note"
        />
    </div>
</template>
<script>
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";
import { required, inArray, date, phone, max, isSelectedCounselor } from '@/utilities/validation.js';
import constants from '@/consts/constants.js'
import CompanyVisit from "./CompanyVisit.vue";
import store from '@/store'
import Swal from 'sweetalert2';
import MemoEditorDialog from '@/components/common/MemoEditorDialog.vue'

export default {
    name: "PartnerSelection",
    components: { CompanyVisit, MemoEditorDialog },
    props: ['date', 'boothNos', 'counselors', 'shop_id', 'historyData', 'showFormMatchingHistory', 'hideTitleForm', 'valueKindForForm', 'customer', 'isLedgerScreen', 'oldHistory', 'isOnlineShop'],

    data: function () {
        const shifts = CUSTOMER.SHIFTS
        const resultTELs = CUSTOMER.RESULT_TELS
        const statusPlan = CUSTOMER.STATUS.getValue('予定')
        const statusImplementation = CUSTOMER.STATUS.getValue('実施')
        const kinds = CUSTOMER.KINDS_FOR_PARTNER_SELECTION.LIST
        const kindVals = CUSTOMER.KINDS_FOR_PARTNER_SELECTION.VAL
        const textField = {
            "member": "会員番号",
            "name": "名前",
            "memberType": "会員種別",
            "shopName": "",
            "date": "",
            "individualResult": "本人結果",
            "opponentResult": "相手結果",
            "comment": "コメント",
        };
        const matchingHistoryDefault = {
            member: '',
            name: '',
            member_type: '',
            shop_name: '',
            individual_result: null,
            opponent_result: null,
            comment: '',
            target_customer_id: null,
            male_customer_id: null,
            female_customer_id: null,
            kind: "",
        }
        const typeCounselors = [
            { label: 'プラチナ', value: 1 },
            { label: 'ゴールド', value: 2 },
            { label: 'お茶見愛', value: 3 },
            { label: 'ｺﾈｸﾄ会員', value: 4 },
            { label: 'お茶マッチ', value: 5 },
        ];
        const individualResults = [
            { label: '〇', value: 2 },
            { label: '✖', value: 3 },
            { label: '△', value: 4 },
            { label: '〇1', value: 5 },
            { label: '〇2', value: 6 },
            { label: '〇3', value: 7 },
            { label: '〇4', value: 8 },
            { label: '〇5', value: 9 },
            { label: '再〇', value: 10 },
            { label: '再✖', value: 11 },
        ];
        const opponentResults = [
            { label: '〇', value: 2 },
            { label: 'お断り', value: 3 },
            { label: '考える', value: 4 },
            { label: '未紹介', value: 5 },
        ];

        return {
            // validate
            rules: {
                kind: [
                    (v) => required(v),
                ],
                boothNo: [
                    () => isSelectedCounselor(this.dataMatchingHistory.counselor_id),
                    (v) => required(v),
                    (v) => inArray(v, this.validBoothNos.map(item => item.id))
                ],
                shift: [
                    (v) => required(v),
                    (v) => inArray(v, shifts.map(item => item.value)),
                ],
                status: [
                    (v) => required(v),
                    (v) => inArray(v, this.status.map(item => item.value)),
                ],
                resultTEL: [
                    (v) => required(v),
                    (v) => inArray(v, resultTELs.map(item => item.value)),
                ],
                target_date: [
                    (v) => required(v),
                    (v) => date(v),
                ],
                target_time: [
                    (v) => required(v),
                ],
                target_time_end: [
                    (v) => required(v),
                ],
                phone: [
                    (v) => required(v),
                    (v) => phone(v),
                    (v) => max(v, 13),
                ],
                family_name: [
                    (v) => required(v),
                ],
                shop: [
                    (v) => required(v),
                ],
                typeCounselor: [
                    (v) => required(v),
                    (v) => inArray(v, typeCounselors.map(item => item.value)),
                ],
                individualResult: [
                    (v) => required(v),
                    (v) => inArray(v, individualResults.map(item => item.value)),
                ],
                opponentResult: [
                    (v) => required(v),
                    (v) => inArray(v, opponentResults.map(item => item.value)),
                ],
                member: [
                    (v) => required(v),
                    // (v) => phone(v),
                    (v) => max(v, 13),
                ],
                note: [
                    (v) => max(v, 1000),
                ],
                counselor: [
                    (v) => required(v),
                ],
            },
            keyRecordMatchingHistory: 1,
            dataMatchingHistory: {
                kind: "",
                status: CUSTOMER.STATUS.getValue('予定'),
                target_date: this.date,
                counselor_id: "",
                target_time: "",
                target_time_end: "",
                customer_id: "",
                booth_no_id: "",
                note: "",
                matching_histories: [],

                type: constants.TYPE_FORM.INPUT_PARTNER_SELECTION,
                option: {
                    result_TEL: false,
                    shift: 0,
                    verTel: false,
                    resTel: false
                },
                isSwitchFormType: false,
                oldHistoryId: "",
                is_online: false,
            },
            statusPlan,
            statusImplementation,
            shifts,
            status: CUSTOMER.STATUS.LIST,
            resultTELs,
            timePick: [],
            phone: "",
            members: [],
            customers: [],
            itemMemberFamilyNames: {
                0: [],
                1: [],
                2: [],
                3: [],
                4: [],
            },
            itemFamilyNames: [],
            isMemberFamilyName: false,
            isFamilyName: false,
            textField,
            matchingHistoryDefault,
            typeCounselors,
            individualResults,
            opponentResults,
            dialogForm: false,
            dialogCV: false,
            addTimeWithKind: 0,
            family_name: '',
            family_name_old: '',
            genderCustomer: '',
            typeSubmit: null,
            showConfirmCustomerSame: false,
            keyChangeCustomerSame: [],
            kindShift: 102, //Kind SHIFT_CONTRACT
            phoneOld: null,
            checkChangePartner: false,
            timer: null,
            matchingHistoriesOld: [],
            isValueForm: [111, 122],
            memberFromHistory: false,
            customerFromHistory: false,
            kinds,
            kindVals,
            validBoothNos: [],
            validCounselors: [],
            moment: moment,
            // memo modal state
            memoDialog: false,
        }
    },
    computed: {
        computedDateFormatted() {
            return this.dataMatchingHistory.target_date ? this.formatDate(this.dataMatchingHistory.target_date) : this.formatDate(this.date)
        },
    },

    watch: {
        showFormMatchingHistory: function (newDialog) {
            this.dialogForm = newDialog
            this.validCounselors = this.counselors
        },
        phone: function (newPhone) {
            if (newPhone) {
                const phone = newPhone.replace(/\D/g, '')
                const firstBlockPhone = phone.substring(0, 3)
                const secondBlockPhone = phone.substring(3, 7)
                const thirdBlockPhone = phone.substring(7)

                let formatPhone = `${firstBlockPhone}`;
                if (secondBlockPhone.length > 0) {
                    formatPhone += `-${secondBlockPhone}`;
                }
                if (thirdBlockPhone.length > 0) {
                    formatPhone += `-${thirdBlockPhone}`;
                }
                this.phone = formatPhone;
            }
        },
        historyData: function (newDataHistory) {
            if (newDataHistory.type == constants.TYPE_FORM.INPUT_PARTNER_SELECTION && this.valueKindForForm.length == 0) {
                this.dataMatchingHistory.kind = newDataHistory.kind
                this.dataMatchingHistory.target_date = this.formatDateSlash(newDataHistory.target_date)
                this.dataMatchingHistory.target_time = newDataHistory.target_time
                this.dataMatchingHistory.target_time_end = newDataHistory.target_time_end
                this.dataMatchingHistory.customer_id = newDataHistory.customer_id
                this.dataMatchingHistory.counselor_id = newDataHistory.counselor_id
                this.dataMatchingHistory.booth_no_id = newDataHistory.booth_no_id
                this.dataMatchingHistory.note = newDataHistory.note
                this.phone = newDataHistory.phone
                this.phoneOld = newDataHistory.phone
                this.family_name = newDataHistory.family_name + newDataHistory.given_name
                this.family_name_old = this.family_name
                this.itemFamilyNames = [this.family_name]
                this.dataMatchingHistory.option.result_TEL = newDataHistory.option.result_TEL
                this.dataMatchingHistory.option.shift = newDataHistory.option.shift
                this.dataMatchingHistory.option.verTel = newDataHistory.option.verTel
                this.dataMatchingHistory.option.resTel = newDataHistory.option.resTel
                this.dataMatchingHistory.status = newDataHistory.status
                this.genderCustomer = newDataHistory.gender
                this.checkChangePartner = true
                this.dataMatchingHistory.matching_histories = newDataHistory.matching_histories.map((item, index) => {
                    this.itemMemberFamilyNames[index] = [item.member_connect != null ? (JSON.parse(item.member_connect).connect_name || (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))) : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))]
                    const result = {
                        member: item.member_connect != null ? JSON.parse(item.member_connect).connect_no : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? item.customer_male.phone_number : item.customer_female.phone_number),
                        name: item.member_connect != null ? (JSON.parse(item.member_connect).connect_name || (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))) : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name)),
                        name_readonly: item.member_connect != null ? false : true,
                        member_type: item.course ? item.course.name : '',
                        individual_result: newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE ? item.male_result : item.female_result,
                        opponent_result: newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE ? item.female_result : item.male_result,
                        comment: item.note,
                        target_customer_id: item.target_customer_id || null,
                        female_history_id: item.female_history_id || null,
                        female_customer_id: item.female_customer_id || null,
                        male_history_id: item.male_history_id || null,
                        male_customer_id: item.male_customer_id || null,
                        kind: item.kind,
                        member_connect: item.member_connect
                    }
                    if (item.member_connect != null) {
                        result.shop_name = 'コネクト会員'
                    } else if (newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE) {
                        result.shop_name = item.customer_female.shop.name
                    } else {
                        result.shop_name = item.customer_male.shop.name
                    }
                    return result
                })

                this.matchingHistoriesOld = newDataHistory.matching_histories.map((item) => {
                    return {
                        member: item.member_connect != null ? JSON.parse(item.member_connect).connect_no : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? item.customer_male.phone_number : item.customer_female.phone_number),
                        name: item.member_connect != null ? (JSON.parse(item.member_connect).connect_name || (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))) : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name)),
                        name_readonly: item.member_connect != null ? false : true,
                        member_type: item.course ? item.course.name : '',
                        individual_result: newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE ? item.male_result : item.female_result,
                        opponent_result: newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE ? item.female_result : item.male_result,
                        comment: item.note,
                        target_customer_id: item.target_customer_id || null,
                        female_history_id: item.female_history_id || null,
                        female_customer_id: item.female_customer_id || null,
                        male_history_id: item.male_history_id || null,
                        male_customer_id: item.male_customer_id || null,
                        kind: item.kind,
                        member_connect: item.member_connect
                    }
                })
                this.typeSubmit = 'update'
                this.validBoothNos = this.boothNos
                this.dataMatchingHistory.is_online = newDataHistory.is_online == 1
                this.getTimeAddWithKind(this.dataMatchingHistory.kind)
            }
        },
        valueKindForForm: function (newValueKindForForm) {
            if (newValueKindForForm) {
                this.dataMatchingHistory = {
                    kind: newValueKindForForm,
                    status: CUSTOMER.STATUS.getValue('予定'),
                    target_date: this.date,
                    counselor_id: "",
                    target_time: "",
                    target_time_end: "",
                    customer_id: "",
                    booth_no_id: "",
                    note: "",
                    matching_histories: [],
                    type: constants.TYPE_FORM.INPUT_PARTNER_SELECTION,
                    option: {
                        result_TEL: false,
                        shift: 0,
                        verTel: false,
                        resTel: false
                    },
                    is_online: this.isOnlineShop ? true : false,
                }
                if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
                    this.customerFromHistory = true
                    this.family_name = this.customer.family_name + this.customer.given_name
                    this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
                    this.phone = this.customer.phone_number
                    this.genderCustomer = this.customer.gender
                    this.dataMatchingHistory.customer_id = this.customer.id
                } else {
                    this.family_name = ''
                    this.phone = ''
                }
                this.typeSubmit = ''
                this.changeKind()
                // お申込み紹介の場合は1行をデフォルトで追加（最大10行）
                if (newValueKindForForm === this.kindVals.SOLO_INTRODUCTION) {
                    this.keyRecordMatchingHistory = this.keyRecordMatchingHistory + 1
                    this.dataMatchingHistory.matching_histories.push({ ...{ key: this.keyRecordMatchingHistory }, ...this.matchingHistoryDefault })
                }
                if (this.isValueForm.includes(newValueKindForForm)) {
                    this.$refs.form.resetValidation()
                }
            }
        },
        date: function (newDate) {
            if (newDate) {
                this.dataMatchingHistory.target_date = newDate
            }
        },
        oldHistory: function (oldHistory) {
            if (oldHistory) {
                this.dataMatchingHistory = {
                    kind: "",
                    status: CUSTOMER.STATUS.getValue('予定'),
                    target_date: this.formatDateSlash(oldHistory.target_date),
                    counselor_id: "",
                    target_time: oldHistory.target_time,
                    target_time_end: oldHistory.target_time_end,
                    customer_id: this.customer.id,
                    booth_no_id: "",
                    note: "",
                    matching_histories: [],
                    type: constants.TYPE_FORM.INPUT_PARTNER_SELECTION,
                    option: {
                        result_TEL: false,
                        shift: 0,
                        verTel: false,
                        resTel: false
                    },
                    isSwitchFormType: true,
                    oldHistoryId: oldHistory.id,
                }
                if (this.customer.id != CUSTOMER.NOT_MEMBER_CUSTOMER && this.customer.id != CUSTOMER.MEMBER_CONNECT) {
                    this.customerFromHistory = true
                    this.family_name = this.customer.family_name + this.customer.given_name
                    this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
                    this.phone = this.customer.phone_number
                    this.genderCustomer = this.customer.gender
                    this.dataMatchingHistory.customer_id = this.customer.id
                } else {
                    this.family_name = ''
                    this.phone = ''
                }
            }
        },
    },

    methods: {
        blurMemberName(e, index) {
            const value = e.target.value
            setTimeout(() => { this.blurMemberNameSetTimeout(e, value, index) }, 100);
        },
        async blurMemberNameSetTimeout(e, value, index) {
            this.isMemberFamilyName = false;
            if (this.dataMatchingHistory.matching_histories[index].name_old) {
                this.itemMemberFamilyNames[index] = [this.dataMatchingHistory.matching_histories[index].name_old]
                this.dataMatchingHistory.matching_histories[index].name = this.dataMatchingHistory.matching_histories[index].name_old
                // this.dataMatchingHistory.matching_histories[index].target_customer_id = this.dataMatchingHistory.matching_histories[index].name_old
                // this.dataMatchingHistory.matching_histories[index].name = this.dataMatchingHistory.matching_histories[index].name_old




                // this.dataMatchingHistory.matching_histories = newDataHistory.matching_histories.map((item, index) => {
                //     this.itemMemberFamilyNames[index][0] = item.member_connect != null ? JSON.parse(item.member_connect).connect_name : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))
                //     return {
                //         member: item.member_connect != null ? JSON.parse(item.member_connect).connect_no : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? item.customer_male.phone_number : item.customer_female.phone_number),
                //         name: item.member_connect != null ? JSON.parse(item.member_connect).connect_name : (newDataHistory.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name)),
                //         name_readonly: item.member_connect != null ? false : true,
                //         member_type: item.course ? item.course.name : '',
                //         url: item.url,
                //         individual_result: newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE ? item.male_result : item.female_result,
                //         opponent_result: newDataHistory.gender == CUSTOMER.GENDER.VAL.MALE ? item.female_result : item.male_result,
                //         comment: item.note,
                //         target_customer_id: item.target_customer_id || null,
                //         female_history_id: item.female_history_id || null,
                //         female_customer_id: item.female_customer_id || null,
                //         male_history_id: item.male_history_id || null,
                //         male_customer_id: item.male_customer_id || null,
                //         kind: item.kind,
                //         member_connect: item.member_connect
                //     }
                // })
            } else {
                this.itemMemberFamilyNames[index] = [value]
                this.dataMatchingHistory.matching_histories[index].name = value

                let member = null
                if (this.dataMatchingHistory.matching_histories[index].member) {
                    const urlParams = new URLSearchParams(window.location.search);
                    const id = urlParams.get('id');
                    let url = `/api/v1/customer/${this.dataMatchingHistory.matching_histories[index].member}/partner/`
                        + "?gender_customer=" + this.genderCustomer
                        + "&customer_id=" + this.dataMatchingHistory.customer_id
                    if (id) {
                        url += '&customer_history_id=' + id
                    }
                    const response = await this.$axios.get(url)
                    member = response.data.dataMember.customer
                }

                if (member) {
                    this.dataMatchingHistory.matching_histories[index].member = ''
                }
                this.dataMatchingHistory.matching_histories[index].member_type = ''

                if (this.dataMatchingHistory.matching_histories[index].name) {
                    this.dataMatchingHistory.matching_histories[index].shop_name = 'コネクト会員'
                } else {
                    this.dataMatchingHistory.matching_histories[index].shop_name = ''
                }

            }
        },
        blurName() {
            if (!this.customer || (this.customer && this.customer.id === 999999999)) {
                this.itemFamilyNames = [this.family_name_old]
                this.family_name = this.family_name_old
                this.isFamilyName = false;
            }
        },
        async debounce(e, timeout = 300) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => { this.searchInputCustomerName(e) }, timeout);
        },
        async debounceMember(e, index, timeout = 300) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => { this.searchInputMemberName(e, index) }, timeout);
        },
        focusCustomerName() {
            this.isFamilyName = true;
        },
        focusMemberName(e, index) {
            this.dataMatchingHistory.matching_histories[index].name_old = ''
            this.isMemberFamilyName = true;
        },
        async searchInputMemberName(e, index) {
            if (!this.isMemberFamilyName || e == null || e == '') {
                return
            }

            if (this.dataMatchingHistory.customer_id == '') {
                alert('相手の情報を入力する前に、携帯番号を入力してください。')
                return false;
            }

            // 1: male, 2: female
            const gender = this.genderCustomer == 1 ? 2 : 1
            const url = '/api/v1/customer/by-name/' + e + '?gender=' + gender
            const response = await this.$axios.get(url)
            this.members = response.data.customers
            this.itemMemberFamilyNames[index] = this.members.map(item => {
                return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
            })
        },
        async searchInputCustomerName(e) {
            if (!this.isFamilyName || e == null || e == '') {
                return
            }
            const url = '/api/v1/customer/by-name/' + e
            const response = await this.$axios.get(url)
            this.customers = response.data.customers
            this.itemFamilyNames = this.customers.map(item => {
                return item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')'
            })
        },
        async inputMemberName(e, index) {
            if (e != null) {
                const members = await this.members.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')
                this.dataMatchingHistory.matching_histories[index].member = members.phone_number.trim()
                await this.getCustomerHistory(index)

                this.itemMemberFamilyNames[index] = await [members.family_name + members.given_name]
                this.dataMatchingHistory.matching_histories[index].name = await members.family_name + members.given_name
                this.dataMatchingHistory.matching_histories[index].name_old = await members.family_name + members.given_name
                this.isMemberFamilyName = false;
            }
        },
        async inputCustomerName(e) {
            if (e == null) {
                this.dataMatchingHistory.customer_id = ''
                return
            }

            const customers = await this.customers.find(item => e == item.family_name + item.given_name + ' (' + item.family_name_kana + item.given_name_kana + ')')

            if (this.checkChangePartner && this.phoneOld != customers.phone_number) {
                if (confirm('携帯番号を変更すると、相手の情報が失われます。変更してもよろしいですか？')) {
                    this.dataMatchingHistory.matching_histories = [
                        { ...{ key: 1 }, ...this.matchingHistoryDefault }
                    ]
                    this.checkChangePartner = false
                    // return false
                } else {
                    this.phone = this.phoneOld
                    return false
                }
            }

            if (Object.keys(customers).length > 0) {
                this.itemFamilyNames = await [customers.family_name + customers.given_name]
                this.family_name = await customers.family_name + customers.given_name
                this.family_name_old = await customers.family_name + customers.given_name
                this.phone = await customers.phone_number;
                this.phoneOld = await customers.phone_number
                this.genderCustomer = await customers.gender;
                this.dataMatchingHistory.customer_id = await customers.id
                if (this.customer && this.customer.shop_id !== null) {
                    this.getCounselorByCustomerShopId(this.dataMatchingHistory.customer_id)
                    this.dataMatchingHistory.counselor_id = ''
                    this.validBoothNos = []
                }
            }

            this.isFamilyName = false;
        },
        formatDateSlash(date) {
            if (!date) return null

            const [year, month, day] = date.split('/')
            return `${year}-${month}-${day}`
        },
        validatePhone() {
            let validate = false;
            validate = this.$refs.phone.validate()
            return validate;
        },

        verifyPhone(e) {
            if (!this.customer || (this.customer && this.customer.id === 999999999)) {
                this.isFamilyName = false;
                this.apiPhone(e)
                this.checkWithMatchingHistories()
            }
        },

        blurGetCustomerHistory(index) {
            this.getCustomerHistory(index)
        },
        apiPhone(e) {
            if (this.checkChangePartner && this.phoneOld != e.target.value) {
                if (confirm('携帯番号を変更すると、相手の情報が失われます。変更してもよろしいですか？')) {
                    this.dataMatchingHistory.matching_histories = [
                        { ...{ key: 1 }, ...this.matchingHistoryDefault }
                    ]
                    this.dataMatchingHistory.customer_id = ''
                    this.checkChangePartner = false
                    this.family_name = ''
                    this.family_name_old = ''
                    this.itemFamilyNames = []
                    // return false
                } else {
                    this.phone = this.phoneOld
                    return false
                }
            }
            const currentUserLoginShopId = store.state.user.shop_id
            const validate = this.validatePhone(e)
            if (validate == false) {
                this.phoneOld = e.target.value
                this.family_name = ''
                this.family_name_old = ''
                this.itemFamilyNames = []
                if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
                    this.dataMatchingHistory.counselor_id = ''
                    this.validCounselors = []
                    this.validBoothNos = []
                }
                return
            }

            this.$axios
                .get("/api/v1/customer/phone_number/" + e.target.value)
                .then((response) => {
                    const customer = response.data.customer
                    if (customer.id != undefined) {
                        this.phoneOld = e.target.value
                        this.family_name = customer.family_name + customer.given_name;
                        this.family_name_old = this.family_name;
                        this.itemFamilyNames = [this.family_name]
                        this.genderCustomer = customer.gender;
                        this.dataMatchingHistory.customer_id = customer.id
                        if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
                            this.dataMatchingHistory.counselor_id = ''
                            this.getCO(customer)
                            this.validBoothNos = []
                        }
                    } else {
                        alert('対象者が存在しません')
                        this.phone = ''
                        this.family_name = ''
                        this.itemFamilyNames = []
                        if (currentUserLoginShopId !== 0 && this.customer && this.customer.shop_id !== null) {
                            this.dataMatchingHistory.counselor_id = ''
                            this.validCounselors = []
                            this.validBoothNos = []
                        }
                        return false;
                    }

                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        async checkWithMatchingHistories() {
            for (let index = 0; index < this.dataMatchingHistory.matching_histories.length; index++) {
                if (this.dataMatchingHistory.matching_histories[index].member == '') {
                    continue
                }

                let url = `/api/v1/customer/${this.dataMatchingHistory.matching_histories[index].member}/partner/`
                    + "?gender_customer=" + this.genderCustomer
                    + "&customer_id=" + this.dataMatchingHistory.customer_id

                const urlParams = new URLSearchParams(window.location.search);
                const id = urlParams.get('id');

                if (id) {
                    url += '&customer_history_id=' + id
                }
                const response = await this.$axios.get(url)

                let checkCustomerSame = false
                checkCustomerSame = response.data.dataMember.isSame
                if (checkCustomerSame) {
                    this.keyChangeCustomerSame.push(index)
                }
            }

            if (this.keyChangeCustomerSame.length > 0) {
                this.showConfirmCustomerSame = true
            }
        },
        getTimeAddFromKind() {
            this.$axios
                .get("/api/v1/date-setting/" + CUSTOMER.EXEC_KIND.VAL.SELECT_MATCH)
                .then((response) => {
                    this.addTimeWithKind = response.data.kind.date_add
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        changeTimeStart(newStartAt) {
            if (newStartAt != "") {
                const startAt = moment(newStartAt, 'HH:mm')
                this.dataMatchingHistory.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
                this.minTime = moment(this.dataMatchingHistory.target_time, 'HH:mm').add(30, 'minutes').format('HH:mm')
            }
        },
        closeDialog() {
            this.$emit('closeFormMatchingHistory')
            this.resetForm()
            this.dialogForm = false
        },
        closeDialogCV() {
            this.dialogCV = false
            this.dataMatchingHistory.option.shift = 0
        },
        onDialog() {
            this.$emit('closeMenu')
            this.dialogForm = true
        },
        addField() {
            const maxRows = this.dataMatchingHistory.kind === this.kindVals.SOLO_INTRODUCTION ? 10 : constants.MAX_MATCHING_HISTORIES
            if (this.dataMatchingHistory.matching_histories.length >= maxRows) {
                return
            }
            this.keyRecordMatchingHistory = this.keyRecordMatchingHistory + 1
            this.dataMatchingHistory.matching_histories.push({ ...{ key: this.keyRecordMatchingHistory }, ...this.matchingHistoryDefault })
        },
        remove(index) {
            delete this.itemMemberFamilyNames[index]
            let arrItemMemberFamilyNames = Object.values(this.itemMemberFamilyNames)
            this.dataMatchingHistory.matching_histories.splice(index, 1)
            const maxRows = this.dataMatchingHistory.kind === this.kindVals.SOLO_INTRODUCTION ? 10 : constants.MAX_MATCHING_HISTORIES
            for (let i = 0; i < maxRows - arrItemMemberFamilyNames.length; i++) {
                arrItemMemberFamilyNames.push([])
            }
            this.itemMemberFamilyNames = Object.assign({}, arrItemMemberFamilyNames)
        },
        openDialogCV() {
            if (this.dataMatchingHistory.option.shift == 1) {
                this.dialogCV = true
            }
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}/${month}/${day}`
        },
        validateForm() {
            const validate = this.$refs.form.validate()
            return validate
        },
        checkHistory() {
        const validate = this.validateForm()
        if (validate == false) {
            return
        }
        let dataHistory = this.dataMatchingHistory
        if (this.historyData?.id) {
            dataHistory.id = this.historyData.id
        }
        this.$axios
            .post("/api/v1/customer/check-history", { dataHistory: dataHistory })
            .then((response) => {
                if (!response.data.canCreate) {
                    let  errorMsg = '以下の予定と重複していますが、登録してよろしいですか？';
                    if (response.data.conflictingAppointmentRes) {
                        const { kind, targetTime, targetTimeEnd, counselorName, boothNoName, customerName } = response.data.conflictingAppointmentRes;
                        errorMsg += `<p style="font-weight: bold;">${CUSTOMER.EXEC_KIND.getName(kind)}</p>`;
                        errorMsg += `<p>時間：${targetTime.slice(0, -3)}〜${targetTimeEnd.slice(0, -3)}</p>`;
                        errorMsg += `<p>${customerName}</p>`;
                        errorMsg += `<p>担当：${counselorName}</p>`;
                        errorMsg += `<p>ブース：${boothNoName || '--'}</p>`;
                    }

                    Swal.fire({
                        html: `<div style="text-align: left; color: #000000de; font-size: 14px; font-family: 'Roboto';">${errorMsg}</div>`,
                        confirmButtonText: `<span style="font-size: 14px;">OK</span>`,
                        confirmButtonColor: "#1e88e5",
                        color: '#ffffff',
                        showCancelButton: true,
                        cancelButtonText: `<span style="font-size: 14px;">Cancel</span>`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.submit()
                        }
                    });
                } else {
                    this.submit()
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async submit() {
            setTimeout(() => { this.submitSetTimeout() }, 200);
        },
        openMemoModal() {
            if (this.memoDialog) return;
            this.memoDialog = true;
            this.$nextTick(() => {
                if (this.$refs.memoTextarea && this.$refs.memoTextarea.$el) {
                    const ta = this.$refs.memoTextarea.$el.querySelector('textarea');
                    ta && ta.blur();
                }
            });
        },
        checkMemoContentAndOpenModal(content, maxLines = 3) {
            if (!content || !content.trim()) return;
            
            const explicitLineCount = content.split(/\r?\n/).length;
            
            if (explicitLineCount > maxLines) {
                this.openMemoModal();
                return;
            }
            
            this.$nextTick(() => {
                const textarea = this.$refs.memoTextarea && this.$refs.memoTextarea.$el
                    ? this.$refs.memoTextarea.$el.querySelector('textarea')
                    : null;
                
                if (textarea) {
                    const originalHeight = textarea.style.height;
                    textarea.style.height = 'auto';
                    
                    const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight) || 24;
                    const visualLines = Math.ceil(textarea.scrollHeight / lineHeight);
                    
                    textarea.style.height = originalHeight;
                    
                    if (visualLines > maxLines) {
                        this.openMemoModal();
                    }
                }
            });
        },
        onMemoInput(val) {
            const content = typeof val === 'string' ? val : (this.dataMatchingHistory.note || '');
            this.checkMemoContentAndOpenModal(content, 3);
        },
        onMemoClick() {
            const content = this.dataMatchingHistory.note || '';
            this.checkMemoContentAndOpenModal(content, 3);
        },
        submitSetTimeout() {
            const validate = this.validateForm()
            if (validate == false) {
                return
            }

            if (this.showConfirmCustomerSame == true) {
                return
            }

            // if (this.dataMatchingHistory.matching_histories.length < 0) {
            //     alert('会員番号が見つかりませんでした。 再度入力してください。')
            //     return;
            // }

            if (this.customerFromHistory) {
                this.dataMatchingHistory.customer_id = this.customer.id
            }
            if (this.dataMatchingHistory.status != this.statusPlan && this.dataMatchingHistory.status != this.statusImplementation) {
                this.dataMatchingHistory.option.verTel = false
                this.dataMatchingHistory.option.resTel = false
            }
            const dataMatchingHistory = this.dataMatchingHistory;
            if (this.dataMatchingHistory.matching_histories.length > 0) {
                this.dataMatchingHistory.matching_histories = this.dataMatchingHistory.matching_histories.map((item) => {
                    let male_result = null; //item.individual_result
                    let female_result = null; //item.female_result
                    let gender = this.genderCustomer == 1 ? 2 : 1
                    if (this.typeSubmit == 'update') {
                        male_result = item.individual_result; //item.individual_result
                        female_result = item.opponent_result; //item.female_result
                        if (this.genderCustomer == 2) {
                            male_result = item.opponent_result; //item.individual_result
                            female_result = item.individual_result; //item.female_result
                        }
                    } else {
                        male_result = item.individual_result; //item.individual_result
                        female_result = item.opponent_result; //item.female_result
                        if (this.genderCustomer == 2) {
                            male_result = item.opponent_result; //item.individual_result
                            female_result = item.individual_result; //item.female_result
                        }
                    }

                    const dataMap = {
                        target_customer_id: item.target_customer_id,
                        kind: item.kind,
                        note: item.comment,
                        date: item.date,
                        male_customer_id: item.male_customer_id || null,
                        female_customer_id: item.female_customer_id || null,
                        male_history_id: item.male_history_id || null,
                        female_history_id: item.female_history_id || null,
                        male_result,
                        female_result,
                        member: item.member,
                        name: item.name,
                        member_type: item.member_type,
                        individual_result: item.individual_result,
                        opponent_result: item.opponent_result,
                        comment: item.comment,
                        customer_history_id: item.customer_history_id,
                        gender,
                    }
                    return dataMap
                })
            }

            if (this.typeSubmit == 'update') {
                this.$axios
                    .put(`/api/v1/customer/${this.dataMatchingHistory.customer_id}/history/${constants.TYPE_FORM.INPUT_PARTNER_SELECTION}`, { historyId: this.historyData.id, historyData: dataMatchingHistory })
                    .then((response) => {
                        this.dialogForm = false
                        this.$emit('refreshListHistory')
                        this.$emit('closeFormMatchingHistory')
                        return response;
                    })
                    .catch((error) => {
                        console.log("Error : " + error);
                    });
            } else {
                this.$axios
                    .post("/api/v1/customer/matching-histories", { dataMatchingHistory: this.dataMatchingHistory })
                    .then((response) => {
                        const isSwitchFormType = this.dataMatchingHistory.isSwitchFormType
                        this.dialogForm = false
                        this.resetForm()
                        this.$emit('refreshCalendar')
                        if (this.valueKindForForm) {
                            this.$emit('refreshListHistory')
                            this.$emit('closeFormMatchingHistory')
                        }
                        if (this.isLedgerScreen) {
                            this.$emit('refreshLedgerData')
                        }
                        if (isSwitchFormType) {
                            this.$router.push({ 
                                path: this.$route.path,
                                query: { id: response.data.data.customerHistory.id }
                            })
                            this.$emit('refreshListHistory')
                            this.$emit('closeFormMatchingHistory')
                        }
                        console.log("Created : id=" + response.data);
                    })
                    .catch((error) => {
                        console.log("Error : " + error);
                    });
            }
        },
        getMonth() {
            return moment(this.value).format("MM")
        },
        menuUp(index) {
            if (index == 0) {
                return;
            }
            this.dataMatchingHistory.matching_histories[index] = this.dataMatchingHistory.matching_histories.splice(
                index - 1, 1, this.dataMatchingHistory.matching_histories[index]
            )[0];
            let valueUpIndex = this.itemMemberFamilyNames[index]
            let valueAfterUpIndex = this.itemMemberFamilyNames[index - 1]
            this.itemMemberFamilyNames[index] = valueAfterUpIndex
            this.itemMemberFamilyNames[index - 1] = valueUpIndex
        },
        menuDown(index) {
            if (index == this.dataMatchingHistory.matching_histories.length - 1) {
                return;
            }

            this.dataMatchingHistory.matching_histories[index] = this.dataMatchingHistory.matching_histories.splice(
                index + 1, 1, this.dataMatchingHistory.matching_histories[index]
            )[0];
            let valueDownIndex = this.itemMemberFamilyNames[index]
            let valueAfterDownIndex = this.itemMemberFamilyNames[index + 1]
            this.itemMemberFamilyNames[index] = valueAfterDownIndex
            this.itemMemberFamilyNames[index + 1] = valueDownIndex;
        },
        async getCustomerHistory(index) {
            // if (this.matchingHistoriesOld.length > 0 && (this.dataMatchingHistory.matching_histories[index].member == (this.matchingHistoriesOld[index] ? this.matchingHistoriesOld[index].member : ''))) {
            //     return false;
            // }
            if (this.dataMatchingHistory.matching_histories[index].member.length > 0) {
                let dataMatchingHistory = this.dataMatchingHistory.matching_histories[index]

                if (this.customerFromHistory) {
                    this.dataMatchingHistory.customer_id = this.customer.id
                }

                if (this.dataMatchingHistory.customer_id == '') {
                    alert('相手の情報を入力する前に、携帯番号や日付などの情報を入力してください。')
                    this.dataMatchingHistory.matching_histories[index].member = ''
                    return false;
                }

                if (this.dataMatchingHistory.matching_histories[index].member == '') {
                    dataMatchingHistory.name = ''
                    dataMatchingHistory.member_type = ''
                    dataMatchingHistory.shop_name = ''
                    dataMatchingHistory.individual_result = null
                    dataMatchingHistory.opponent_result = null
                    dataMatchingHistory.comment = ''
                }

                if (this.phone.trim() == this.dataMatchingHistory.matching_histories[index].member.trim()) {
                    alert('別の携帯番号（会員番号）を入力してください。')
                    this.dataMatchingHistory.matching_histories[index].member = ''
                    return false;
                }
                let checkSameMember = 0;
                this.dataMatchingHistory.matching_histories.map(item => {
                    if ((item.member == this.dataMatchingHistory.matching_histories[index].member) && this.dataMatchingHistory.matching_histories[index].member != '') {
                        checkSameMember = checkSameMember + 1;
                    }

                    if (checkSameMember > 1) {
                        alert('会員番号が重複しています。再度入力してください。')
                        this.dataMatchingHistory.matching_histories[index].member = ''
                        return false;
                    }
                })

                try {
                    let member = null
                    let checkCustomerSame = false
                    if (this.dataMatchingHistory.matching_histories[index].member) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const id = urlParams.get('id');
                        let url = `/api/v1/customer/${this.dataMatchingHistory.matching_histories[index].member}/partner/`
                            + "?gender_customer=" + this.genderCustomer
                            + "&customer_id=" + this.dataMatchingHistory.customer_id
                        if (id) {
                            url += '&customer_history_id=' + id
                        }

                        const response = await this.$axios.get(url)
                        member = response.data.dataMember.customer
                        checkCustomerSame = response.data.dataMember.isSame
                    }
                    // let memberConnect = response.data.dataMember.memberConnect

                    if (checkCustomerSame) {
                        this.keyChangeCustomerSame.push(index)
                        this.showConfirmCustomerSame = true
                    }

                    // if (member == null && memberConnect == null) {
                    //     dataMatchingHistory.member = ''
                    //     dataMatchingHistory.name = ''
                    //     dataMatchingHistory.member_type = ''
                    //     dataMatchingHistory.individual_result = ''
                    //     dataMatchingHistory.opponent_result = ''
                    //     dataMatchingHistory.comment = ''
                    //     dataMatchingHistory.target_customer_id = ''
                    //     dataMatchingHistory.male_customer_id = ''
                    //     dataMatchingHistory.female_customer_id = ''
                    //     dataMatchingHistory.kind = ''
                    //     alert('会員番号が見つかりませんでした。 再度入力してください。')
                    //     return false;
                    // }

                    if (member != null) {
                        dataMatchingHistory.member_type = member.customer_course[0] && member.customer_course[0].course ? member.customer_course[0].course.name : null
                        dataMatchingHistory.shop_name = member.shop.name || ''
                        this.itemMemberFamilyNames[index] = [member.family_name + member.given_name]
                        dataMatchingHistory.name = member.family_name + member.given_name
                        dataMatchingHistory.name_old = member.family_name + member.given_name
                        dataMatchingHistory.target_customer_id = this.dataMatchingHistory.customer_id
                        dataMatchingHistory.kind = member.customer_course[0] && member.customer_course[0].course ? member.customer_course[0].course.id : null
                        dataMatchingHistory.date = this.computedDateFormatted
                        if (this.genderCustomer == 1) {
                            dataMatchingHistory.female_customer_id = member.id || null;
                            dataMatchingHistory.male_customer_id = this.dataMatchingHistory.customer_id || null

                        }
                        if (this.genderCustomer == 2) {
                            dataMatchingHistory.male_customer_id = member.id || null;
                            dataMatchingHistory.female_customer_id = this.dataMatchingHistory.customer_id || null
                        }
                        dataMatchingHistory.name_readonly = true;
                    }
                    if (member == null) {
                        // dataMatchingHistory.name = ''
                        dataMatchingHistory.member_type = ''
                        dataMatchingHistory.shop_name = 'コネクト会員'
                        // dataMatchingHistory.individual_result = null
                        // dataMatchingHistory.opponent_result = null
                        // dataMatchingHistory.comment = ''

                        // dataMatchingHistory.name = memberConnect.connect_name
                        dataMatchingHistory.target_customer_id = this.dataMatchingHistory.customer_id
                        dataMatchingHistory.date = this.computedDateFormatted
                        dataMatchingHistory.kind = null
                        if (this.genderCustomer == 1) {
                            dataMatchingHistory.female_customer_id = CUSTOMER.MEMBER_CONNECT;
                            dataMatchingHistory.male_customer_id = this.dataMatchingHistory.customer_id || null

                        }
                        if (this.genderCustomer == 2) {
                            dataMatchingHistory.male_customer_id = CUSTOMER.MEMBER_CONNECT;
                            dataMatchingHistory.female_customer_id = this.dataMatchingHistory.customer_id || null
                        }
                        dataMatchingHistory.name_readonly = false;
                    }
                    this.checkChangePartner = true

                } catch (error) {
                    console.log("Error : " + error);
                }
            }
        },
        resetForm() {
            this.$refs.form.resetValidation()
            this.phone = ''
            if (this.typeSubmit == 'update' && this.dataMatchingHistory.option.shift == 1) {
                this.dataMatchingHistory = {
                    kind: "",
                    status: CUSTOMER.STATUS.getValue('予定'),
                    target_date: this.date,
                    counselor_id: "",
                    target_time: "",
                    target_time_end: "",
                    customer_id: "",
                    booth_no_id: "",
                    note: "",
                    matching_histories: [],
                    type: constants.TYPE_FORM.INPUT_PARTNER_SELECTION,
                    option: {
                        result_TEL: false,
                        shift: 1,
                    },
                }
                this.family_name = ''
            } else if (this.typeSubmit == 'update') {
                if (this.historyData.type == constants.TYPE_FORM.INPUT_PARTNER_SELECTION && this.valueKindForForm.length == 0) {
                    this.dataMatchingHistory.kind = this.historyData.kind
                    this.dataMatchingHistory.target_date = this.formatDateSlash(this.historyData.target_date)
                    this.dataMatchingHistory.target_time = this.historyData.target_time
                    this.dataMatchingHistory.target_time_end = this.historyData.target_time_end
                    this.dataMatchingHistory.customer_id = this.historyData.customer_id
                    this.dataMatchingHistory.counselor_id = this.historyData.counselor_id
                    this.dataMatchingHistory.booth_no_id = this.historyData.booth_no_id
                    this.dataMatchingHistory.note = this.historyData.note
                    this.phone = this.historyData.phone
                    this.family_name = this.historyData.family_name + this.historyData.given_name
                    this.itemFamilyNames = [this.family_name]
                    this.dataMatchingHistory.option.result_TEL = this.historyData.option.result_TEL
                    this.dataMatchingHistory.option.shift = this.historyData.option.shift
                    this.dataMatchingHistory.status = this.historyData.status
                    this.genderCustomer = this.historyData.gender
                    this.dataMatchingHistory.matching_histories = this.historyData.matching_histories.map((item, index) => {
                        this.itemMemberFamilyNames[index] = [item.member_connect != null ? (JSON.parse(item.member_connect).connect_name || (this.historyData.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))) : (this.historyData.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))]
                        return {
                            target_customer_id: this.historyData.customer_id,
                            member: item.member_connect != null ? JSON.parse(item.member_connect).connect_no : (this.historyData.gender != CUSTOMER.GENDER.VAL.MALE ? item.customer_male.phone_number : item.customer_female.phone_number),
                            name: item.member_connect != null ? (JSON.parse(item.member_connect).connect_name || (this.historyData.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name))) : (this.historyData.gender != CUSTOMER.GENDER.VAL.MALE ? (item.customer_male.family_name + item.customer_male.given_name) : (item.customer_female.family_name + item.customer_female.given_name)),
                            member_type: item.course ? item.course.name : '',
                            individual_result: this.historyData.gender == CUSTOMER.GENDER.VAL.MALE ? item.male_result : item.female_result,
                            opponent_result: this.historyData.gender == CUSTOMER.GENDER.VAL.MALE ? item.female_result : item.male_result,
                            comment: item.note,
                            female_history_id: item.female_history_id || null,
                            male_history_id: item.male_history_id || null,
                            male_customer_id: item.male_customer_id || null,
                            female_customer_id: item.female_customer_id || null,
                            kind: item.kind,
                            member_connect: item.member_connect
                        }
                    })
                }
            } else {
                this.dataMatchingHistory = {
                    kind: "",
                    status: CUSTOMER.STATUS.getValue('予定'),
                    target_date: this.date,
                    counselor_id: "",
                    target_time: "",
                    target_time_end: "",
                    customer_id: "",
                    booth_no_id: "",
                    note: "",
                    matching_histories: [],
                    type: constants.TYPE_FORM.INPUT_PARTNER_SELECTION,
                    option: {
                        result_TEL: false,
                        shift: 0,
                    },
                }
                this.family_name = ''

                if (this.customerFromHistory) {
                    this.family_name = this.customer.family_name + this.customer.given_name
                    this.itemFamilyNames = [this.customer.family_name + this.customer.given_name]
                    this.phone = this.customer.phone_number
                    this.genderCustomer = this.customer.gender
                    this.dataMatchingHistory.customer_id = this.customer.id
                }
            }

            if (this.valueKindForForm) {
                this.dataMatchingHistory.kind = this.valueKindForForm
            }
        },
        changeCustomerSame() {
            for (let index = 0; index < this.keyChangeCustomerSame.length; index++) {
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].member = ''
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].name = ''
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].member_type = ''
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].shop_name = ''
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].individual_result = null
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].opponent_result = null
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].comment = ''
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].target_customer_id = null
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].male_customer_id = null
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].female_customer_id = null
                this.dataMatchingHistory.matching_histories[this.keyChangeCustomerSame[index]].kind = ''
            }
            this.keyChangeCustomerSame = []
            this.showConfirmCustomerSame = false
        },
        closePopChangeCustomerSame() {
            this.showConfirmCustomerSame = false
            this.keyChangeCustomerSame = []
        },
        saveTimeStart() {
            this.changeTimeStart(this.dataMatchingHistory.target_time)
            this.$refs.dialog1.save(this.dataMatchingHistory.target_time)
        },
        formatNumberPhone(index) {
            const phone = this.dataMatchingHistory.matching_histories[index].member.replace(/\D/g, '')
            const firstBlockPhone = phone.substring(0, 3)
            const secondBlockPhone = phone.substring(3, 7)
            const thirdBlockPhone = phone.substring(7)

            let formatPhone = `${firstBlockPhone}`;
            if (secondBlockPhone.length > 0) {
                formatPhone += `-${secondBlockPhone}`;
            }
            if (thirdBlockPhone.length > 0) {
                formatPhone += `-${thirdBlockPhone}`;
            }
            this.dataMatchingHistory.matching_histories[index].member = formatPhone
        },
        changeKind() {
            this.$axios
                .get("/api/v1/date-setting/" + this.dataMatchingHistory.kind)
                .then((response) => {
                    this.addTimeWithKind = response.data.kind.date_add
                    if (this.dataMatchingHistory.target_time != "") {
                        const startAt = moment(this.dataMatchingHistory.target_time, 'HH:mm')
                        this.dataMatchingHistory.target_time_end = startAt.isBefore(moment('23:10', 'HH:mm')) ? startAt.add(this.addTimeWithKind, 'minutes').format('HH:mm') : '23:59';
                    }
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        async getTimeAddWithKind(kind) {
            if (kind) {
                await this.$axios
                .get("/api/v1/date-setting/" + kind)
                .then((response) => {
                    this.addTimeWithKind = response.data.kind.date_add
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
            }
        },
        async onCounselorSelected() {
            const validCounselors = this.customer && this.customer.shop_id !== null ? this.validCounselors : this.counselors
            const counselorSelected = validCounselors.find(counselor => counselor.id === this.dataMatchingHistory.counselor_id)
            await this.$axios.get(`/api/v1/booth_no/shop/${counselorSelected.shop_id}`)
                .then((response) => {
                    this.validBoothNos = response.data.booth_nos;
                    if (response.data.booth_nos.length > 0 && response.data?.booth_nos[0]?.shop_id != counselorSelected.shop_id) {
                      this.dataMatchingHistory.booth_no_id = "";
                    }
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        getCO(customer) {
            this.$axios
                .get(`/api/v1/user/counselors?shop_id=${customer.shop_id}`)
                .then((response) => {
                    this.validCounselors = response.data.counselors
                })
                .catch((error) => {
                    console.log("Error : " + error)
                })
        },
        getCounselorByCustomerShopId(customerId) {
            if (customerId) {
                this.$axios
                    .get(`/api/v1/customer/${customerId}`)
                    .then((response) => {
                        const customer = response.data.customer
                        if (customer.id != undefined) {
                            this.getCO(customer)
                        } else {
                            alert('対象者が存在しません')
                            this.validCounselors = []
                            this.validBoothNos = []
                            return false
                        }
                    })
                    .catch((error) => {
                        console.log("Error : " + error)
                    })
            }
        },
    },
};
</script>

<style scoped>
.body-content-dialog {
    height: calc(100vh - 210px);
    overflow-y: auto;
}

.container.grid-list-md .layout .flex {
    padding: 4px 12px;
}

.mdi-menu {
    opacity: 0.2;
}

.matching_histories:hover .mdi-menu {
    opacity: 1;
}

/* Clickable textarea styling */
.clickable-textarea {
  cursor: pointer;
}

.memo-modal-textarea ::v-deep .v-text-field__slot textarea {
  min-height: 120px !important;
  max-height: unset !important;
  line-height: 24px !important;
  padding: 12px !important;
  font-size: 14px !important;
  overflow-y: auto !important;
  resize: vertical !important;
}
</style>